import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_PARTNERS = 'GET_PARTNERS';

export const actions = createSagaActionTypes('PARTNERS', [GET_PARTNERS]);
